import frontendLogger from "../utils/frontendLogger.js";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../app_config.js";

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const forgotPassword = () => navigate("/forgot-password");
  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      console.log("Login submit:", { username });
      const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password }),
      });

      const text = await response.text();
      let data;
      try {
        data = text ? JSON.parse(text) : {};
      } catch (parseErr) {
        frontendLogger.warn(
          "Failed to parse login JSON response:",
          parseErr,
          "text:",
          text,
        );
        data = { message: text || "Invalid server response" };
      }

      frontendLogger.info("Login response:", response.status, data);

      if (!response.ok) {
        const msg = data.message || "Login fehlgeschlagen";
        setError(msg);
        frontendLogger.error("Login failed:", response.status, msg);
      } else if (!data.token) {
        const msg = "Token nicht erhalten";
        setError(msg);
        frontendLogger.error("Login succeeded but token missing:", data);
      } else {
        localStorage.setItem("token", data.token);
        setUsername("");
        setPassword("");
        navigate("/main");
      }
    } catch (err) {
      setError(
        "Ein Fehler ist aufgetreten. Bitte versuche es erneut. " + err.message,
      );
      frontendLogger.error("Login error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>DRAM Login</h1>
        <h3>Digital Review and Aroma Manager</h3>
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label htmlFor="username">Benutzername</label>
            <input
              type="text"
              id="username"
              data-testid="username-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Gib deinen Benutzernamen ein"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Passwort</label>
            <input
              type="password"
              id="password"
              data-testid="password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Gib dein Passwort ein"
              required
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          <div className="login-nav">
            <button
              type="submit"
              disabled={loading}
              data-testid="submit_button"
            >
              {loading ? "Anmelden..." : "Anmelden"}
            </button>
          </div>
          <div className="nav">
            <button
              type="button"
              onClick={forgotPassword}
              data-testid="forgotPassword_button"
            >
              Passwort vergessen
            </button>
          </div>
          <div className="form-footer">
            <Link
              className="privacy-link"
              to="/privacy"
              data-testid="privacy-link"
            >
              Datenschutzerklärung
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;
